import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ProcesosBuilder.css";

const API = "https://wwwa.isepsantafe.net.ar/expedientes/ingresos";
// Ajustar esta ruta si el endpoint del backend tiene otro nombre.
const FORMULARIOS_URL = `${API}/obtenerFormulariosActivos`;

const normalizarFormularios = (respuesta) => {
  const lista = Array.isArray(respuesta) ? respuesta
    : [respuesta?.formularios, respuesta?.data, respuesta?.rows, respuesta?.resultados]
        .find(Array.isArray) || [];
  return lista.map((f) => ({
    id: Number(f.id ?? f.formularioId ?? f.formulario_id),
    nombre: String(f.nombre ?? f.titulo ?? f.descripcion ?? f.name ?? "Sin nombre"),
  })).filter(f => Number.isSafeInteger(f.id) && f.id > 0)
    .sort((a, b) => a.id - b.id);
};

const ESCUELAS = ["Escuela de Policia", "Escuela de Investigaciones", "Escuela Superior", "Escuela de Especialidades"];
const TIPOS_PROCESO = ["Ingreso", "Perfeccionamiento", "Cadetes"];
const ESTADOS_PROCESO = ["Activo", "Inactivo", "Finalizado"];


// Sintaxis persistida: numerico, numerico>4, numerico>=4, numerico<10, numerico<=10, numerico=5.
const leerReglaNumerica = (observacion) => {
  const texto = String(observacion ?? "").trim();
  const m = texto.match(/^numerico\s*(?:(>=|<=|>|<|=)\s*(-?\d+(?:[.,]\d+)?))?$/i);
  if (m) return { numerico: true, operador: m[1] || "", umbral: m[2] ? m[2].replace(",", ".") : "" };
  try {
    const obj = JSON.parse(texto);
    if (obj?.tipo === "numerico") return { numerico: true, operador: obj.operador || "", umbral: String(obj.umbral ?? "") };
  } catch (_) {}
  return { numerico: false, operador: "", umbral: "" };
};

const armarReglaNumerica = (data) => {
  if (data.tipo !== "evaluacion" || !data.evaluacionNumerica) return data.observacion || null;
  if (!data.operadorNumerico) return "numerico";
  const valor = String(data.umbralNumerico ?? "").trim().replace(",", ".");
  if (!/^-?\d+(?:\.\d+)?$/.test(valor)) throw new Error("Ingresá un valor de referencia numérico válido.");
  return `numerico${data.operadorNumerico}${valor}`;
};

const ControlesReglaNumerica = ({ data, actualizar }) => data.tipo === "evaluacion" ? (
  <div className="pb-form" style={{ padding: 12, marginTop: 10, border: "1px solid #cbd5e1", borderRadius: 8 }}>
    <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <input type="checkbox" checked={!!data.evaluacionNumerica} onChange={e => actualizar("evaluacionNumerica", e.target.checked)} />
      Evaluación con calificación numérica
    </label>
    {data.evaluacionNumerica && <div className="pb-fields" style={{ marginTop: 10 }}>
      <label>Regla automática
        <select value={data.operadorNumerico || ""} onChange={e => actualizar("operadorNumerico", e.target.value)}>
          <option value="">Solo cargar nota (sin aprobar/rechazar)</option>
          <option value=">">Mayor que (&gt;)</option>
          <option value=">=">Mayor o igual que (&gt;=)</option>
          <option value="<">Menor que (&lt;)</option>
          <option value="<=">Menor o igual que (&lt;=)</option>
          <option value="=">Igual que (=)</option>
        </select>
      </label>
      {data.operadorNumerico && <label>Valor de referencia
        <input type="text" inputMode="decimal" placeholder="Ej.: 4.5" value={data.umbralNumerico ?? ""} onChange={e => actualizar("umbralNumerico", e.target.value)} />
      </label>}
      <p className="pb-meta">Se guardará en observación: <strong>{data.operadorNumerico ? `numerico${data.operadorNumerico}${data.umbralNumerico ?? ""}` : "numerico"}</strong></p>
    </div>}
  </div>
) : null;

const ProcesosBuilder = () => {
  const [procesos, setProcesos] = useState([]);
  const [procesoSeleccionado, setProcesoSeleccionado] = useState(null);

  const [etapaActiva, setEtapaActiva] = useState(null);
  const [instanciaActiva, setInstanciaActiva] = useState(null);

  const [nombreProceso, setNombreProceso] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [formularioId, setFormularioId] = useState("");
  const [formularios, setFormularios] = useState([]);
  const [cargandoFormularios, setCargandoFormularios] = useState(false);
  const [errorFormularios, setErrorFormularios] = useState("");
  const [usarIdManual, setUsarIdManual] = useState(false);
  const [escuelaProceso, setEscuelaProceso] = useState("");
  const [tipoProceso, setTipoProceso] = useState("");
  const [estadoProceso, setEstadoProceso] = useState("Activo");
  const [fechasProceso, setFechasProceso] = useState({
    fecha_inicio: "", fecha_finalizacion: "",
    fecha_inicio_recurrir: "", fecha_finalizacion_recurrir: "",
  });
  const [errorGeneral, setErrorGeneral] = useState("");
  const [guardandoProceso, setGuardandoProceso] = useState(false);

  const [etapaForm, setEtapaForm] = useState({});
  const [etapaEdit, setEtapaEdit] = useState(null);
  const [guardandoEtapa, setGuardandoEtapa] = useState(false);
  const [errorEtapa, setErrorEtapa] = useState("");
  const [instanciaForm, setInstanciaForm] = useState({});
  const [itemForm, setItemForm] = useState({});

  const [editing, setEditing] = useState({});
  const [instanciaEdit, setInstanciaEdit] = useState(null);
  const [itemEdit, setItemEdit] = useState(null);
  const [guardandoDetalle, setGuardandoDetalle] = useState(false);
  const [errorDetalle, setErrorDetalle] = useState("");
  const [mostrarCrearProceso, setMostrarCrearProceso] = useState(false);
  const [mostrarCrearEtapa, setMostrarCrearEtapa] = useState(false);
  const [mostrarCrearInstancia, setMostrarCrearInstancia] = useState(false);
  const [mostrarCrearItem, setMostrarCrearItem] = useState(false);

  const mensajeServidor = (e) => {
    const data = e?.response?.data;
    const mensaje = typeof data === "string" ? data :
      data?.message || data?.mensaje || data?.error || data?.detail || data?.details;
    const texto = typeof mensaje === "string" ? mensaje : mensaje ? JSON.stringify(mensaje) :
      (e?.response ? "El servidor no proporcionó detalles." : e?.message || "Error de conexión");
    return `${e?.response?.status ? `HTTP ${e.response.status}: ` : ""}${texto}`;
  };

  const informarError = (e, setter = setErrorGeneral) => {
    const mensaje = mensajeServidor(e);
    console.error("Error en ProcesosBuilder:", e?.response?.status, e?.response?.data || e);
    setter(mensaje);
  };

  const roles = [
    "Sanidad",
    "Psicologia",
    "Reclutamiento",
    "ISeP",
    "Postulante",
  ];

  const setEditingValue = (key, value) => {
    setEditing((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const guardarEdicion = async (type, id, campo = "nombre") => {
    setErrorGeneral("");
    try {
    const value = editing[`${type}-${id}`];

    await axios.post(`${API}/editar${type}`, {
      id,
      [campo]: value,
    });

    setEditing((prev) => {
      const copy = { ...prev };
      delete copy[`${type}-${id}`];
      return copy;
    });

    await recargarProceso(procesoSeleccionado.id);

    } catch (e) { informarError(e); }
  };

  const eliminar = async (type, id) => {
    setErrorGeneral("");
    try {
    if (!window.confirm("¿Eliminar?")) return;

    await axios.post(`${API}/eliminar${type}`, { id });

    await recargarProceso(procesoSeleccionado.id);
    if (type === "Etapa" && etapaActiva?.id === id) { setEtapaActiva(null); setEtapaEdit(null); }
    if (type === "Instancia" && instanciaActiva?.id === id) setInstanciaActiva(null);

    } catch (e) { informarError(e); }
  };

  const mover = async (type, item, direccion) => {
    setErrorGeneral("");
    try {
    await axios.post(`${API}/reordenar${type}`, {
      id: item.id,
      direccion,
    });

    await recargarProceso(procesoSeleccionado.id);

    } catch (e) { informarError(e); }
  };

  const renderEditable = (type, item) => {
    const key = `${type}-${item.id}`;
    const isEditing = editing[key] !== undefined;

    if (isEditing) {
      return (
        <input
          autoFocus
          value={editing[key]}
          onChange={(e) => setEditingValue(key, e.target.value)}
          onBlur={() => guardarEdicion(type, item.id)}
          onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
        />
      );
    }

    return (
      <span
        style={{ cursor: "pointer", fontWeight: 600 }}
        onClick={() => setEditingValue(key, item.nombre)}
      >
        {item.nombre}
      </span>
    );
  };

  const setForm = (setter, key, field, value) => {
    setter((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };

  const cargarProcesos = async () => {
    const res = await axios.post(`${API}/listarProcesos`);
    setProcesos(res.data);
  };

  const recargarProceso = async (id) => {
    const res = await axios.post(`${API}/getProcesoCompleto`, {
      proceso_id: id,
    });

    setProcesoSeleccionado(res.data);
  };

  useEffect(() => {
    cargarProcesos().catch(e => informarError(e));
  }, []);

  const cargarFormularios = async () => {
    setCargandoFormularios(true);
    setErrorFormularios("");
    try {
      const res = await axios.post(FORMULARIOS_URL);
      const lista = normalizarFormularios(res.data);
      setFormularios(lista);
      if (!lista.length) setErrorFormularios("La consulta no devolvió formularios válidos.");
    } catch (e) {
      setFormularios([]);
      setErrorFormularios(mensajeServidor(e));
      console.error("Error cargando formularios:", e?.response?.data || e);
    } finally {
      setCargandoFormularios(false);
    }
  };

  useEffect(() => {
    if (mostrarCrearProceso) cargarFormularios();
  }, [mostrarCrearProceso]);

  const crearProceso = async () => {
    if (guardandoProceso) return;
    setErrorGeneral("");
    if (!nombreProceso.trim()) return setErrorGeneral("Ingresá el nombre del proceso.");
    if (!formularioId.trim() || !Number.isSafeInteger(Number(formularioId)) || Number(formularioId) <= 0)
      return setErrorGeneral("Ingresá un ID de formulario válido (entero positivo).");
    if (!usarIdManual && !formularios.some(f => String(f.id) === formularioId))
      return setErrorGeneral("Seleccioná un formulario de la lista.");
    if (!escuelaProceso) return setErrorGeneral("Seleccioná la escuela.");
    if (!tipoProceso) return setErrorGeneral("Seleccioná el tipo de proceso.");
    if (fechasProceso.fecha_inicio && fechasProceso.fecha_finalizacion && fechasProceso.fecha_inicio > fechasProceso.fecha_finalizacion)
      return setErrorGeneral("La fecha de finalización no puede ser anterior a la fecha de inicio.");
    if (fechasProceso.fecha_inicio_recurrir && fechasProceso.fecha_finalizacion_recurrir && fechasProceso.fecha_inicio_recurrir > fechasProceso.fecha_finalizacion_recurrir)
      return setErrorGeneral("El cierre de recursiva no puede ser anterior a su apertura.");
    setGuardandoProceso(true);
    try {
      const res = await axios.post(`${API}/crearProceso`, {
        nombre: nombreProceso.trim(),
        descripcion: descripcion.trim() || null,
        formularioId: Number(formularioId),
        Escuela: escuelaProceso,
        Tipo: tipoProceso,
        estado: estadoProceso,
        ...Object.fromEntries(Object.entries(fechasProceso).map(([key, value]) => [key, value ? new Date(value).toISOString() : null])),
      });
      setNombreProceso(""); setDescripcion(""); setFormularioId("");
      setMostrarCrearProceso(false);
      try {
        await cargarProcesos();
        await abrirProceso(res.data);
      } catch (e) { informarError(e); }
    } catch (e) { informarError(e); }
    finally { setGuardandoProceso(false); }
  };

  const abrirProceso = async (proceso) => {
    setEtapaActiva(null);
    setInstanciaActiva(null);
    setEtapaEdit(null);
    setMostrarCrearEtapa(false);
    setMostrarCrearInstancia(false);
    setMostrarCrearItem(false);
    await recargarProceso(proceso.id);
  };

  const toLocalInput = (valor) => {
    if (!valor) return "";
    const fecha = new Date(valor);
    if (Number.isNaN(fecha.getTime())) return "";
    const local = new Date(fecha.getTime() - fecha.getTimezoneOffset() * 60000);
    return local.toISOString().slice(0, 16);
  };

  const toISO = (valor) => valor ? new Date(valor).toISOString() : null;

  const etapaPayload = (data) => ({
    nombre: data.nombre?.trim() || "",
    observacion: data.observacion || null,
    visibilidad: data.visibilidad || null,
    fecha_inicio: toISO(data.fecha_inicio),
    fecha_finalizacion: toISO(data.fecha_finalizacion),
    permite_recursiva: !!data.permite_recursiva,
    fecha_inicio_recursiva: toISO(data.fecha_inicio_recursiva),
    fecha_fin_recursiva: toISO(data.fecha_fin_recursiva),
  });

  const validarEtapa = (data) => {
    if (!data.nombre?.trim()) return "El nombre de la etapa es obligatorio";
    if (data.fecha_inicio && data.fecha_finalizacion && data.fecha_inicio > data.fecha_finalizacion) {
      return "La finalización de la etapa no puede ser anterior al inicio";
    }
    if (data.permite_recursiva) {
      if (!data.fecha_inicio_recursiva || !data.fecha_fin_recursiva) {
        return "Para habilitar recursiva, indicá fecha y hora de apertura y cierre";
      }
      if (data.fecha_inicio_recursiva > data.fecha_fin_recursiva) {
        return "El cierre de recursiva no puede ser anterior a su apertura";
      }
    }
    return null;
  };

  const cargarEdicionEtapa = (etapa) => {
    setErrorEtapa("");
    setEtapaEdit({
      id: etapa.id,
      nombre: etapa.nombre || "",
      observacion: etapa.observacion || "",
      visibilidad: etapa.visibilidad || "",
      fecha_inicio: toLocalInput(etapa.fecha_inicio),
      fecha_finalizacion: toLocalInput(etapa.fecha_finalizacion),
      permite_recursiva: !!etapa.permite_recursiva,
      fecha_inicio_recursiva: toLocalInput(etapa.fecha_inicio_recursiva),
      fecha_fin_recursiva: toLocalInput(etapa.fecha_fin_recursiva),
    });
  };

  const guardarEtapaCompleta = async () => {
    if (!etapaEdit || guardandoEtapa) return;
    const error = validarEtapa(etapaEdit);
    if (error) { setErrorEtapa(error); return; }
    setGuardandoEtapa(true);
    setErrorEtapa("");
    try {
      await axios.post(`${API}/editarEtapa`, {
        id: etapaEdit.id,
        ...etapaPayload(etapaEdit),
      });
      await recargarProceso(procesoSeleccionado.id);
      setEtapaEdit(null);
    } catch (error) {
      informarError(error, setErrorEtapa);
    } finally {
      setGuardandoEtapa(false);
    }
  };

  const camposEtapa = (data, actualizar) => (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: 12, marginTop: 12 }}>
      <label>Nombre de la etapa
        <input style={{ display: "block", width: "100%" }} value={data.nombre || ""} onChange={(e) => actualizar("nombre", e.target.value)} />
      </label>
      <label>Visibilidad
        <input style={{ display: "block", width: "100%" }} placeholder="Visibilidad" value={data.visibilidad || ""} onChange={(e) => actualizar("visibilidad", e.target.value)} />
      </label>
      <label style={{ gridColumn: "1 / -1" }}>Observación
        <textarea style={{ display: "block", width: "100%", minHeight: 55 }} value={data.observacion || ""} onChange={(e) => actualizar("observacion", e.target.value)} />
      </label>
      {[
        ["fecha_inicio", "Inicio de la etapa"],
        ["fecha_finalizacion", "Finalización de la etapa"],
      ].map(([campo, etiqueta]) => (
        <label key={campo}>{etiqueta}
          <input type="datetime-local" style={{ display: "block", width: "100%" }} value={data[campo] || ""} onChange={(e) => actualizar(campo, e.target.value)} />
        </label>
      ))}
      <label style={{ gridColumn: "1 / -1" }}>
        <input type="checkbox" checked={!!data.permite_recursiva} onChange={(e) => actualizar("permite_recursiva", e.target.checked)} /> Habilitar solicitudes de recursiva para esta etapa
      </label>
      {[
        ["fecha_inicio_recursiva", "Apertura de recursiva"],
        ["fecha_fin_recursiva", "Cierre de recursiva"],
      ].map(([campo, etiqueta]) => (
        <label key={campo}>{etiqueta}
          <input type="datetime-local" disabled={!data.permite_recursiva} style={{ display: "block", width: "100%" }} value={data[campo] || ""} onChange={(e) => actualizar(campo, e.target.value)} />
        </label>
      ))}
    </div>
  );

  const crearEtapa = async () => {
    const data = etapaForm[procesoSeleccionado.id] || {};
    const error = validarEtapa(data);
    if (error) { setErrorEtapa(error); return; }
    setErrorEtapa("");
    try {
      setGuardandoEtapa(true);
      await axios.post(`${API}/crearEtapa`, {
        proceso_id: procesoSeleccionado.id,
        ...etapaPayload(data),
      });
      setEtapaForm({});
      setMostrarCrearEtapa(false);
      await recargarProceso(procesoSeleccionado.id);
    } catch (error) {
      informarError(error, setErrorEtapa);
    } finally { setGuardandoEtapa(false); }
  };

  const abrirEtapa = (etapa) => {
    setEtapaActiva(etapa);
    setEtapaEdit(null);
    setInstanciaActiva(null);
    setInstanciaEdit(null); setItemEdit(null);
    setMostrarCrearInstancia(false);
    setMostrarCrearItem(false);
  };

  const crearInstancia = async () => {
    setErrorGeneral("");
    try {
    const data = instanciaForm[etapaActiva.id] || {};

    await axios.post(`${API}/createInstanciaEtapa`, {
      proceso_etapa_id: etapaActiva.id,
      nombre: data.nombre,
    });

    setInstanciaForm({});
    setMostrarCrearInstancia(false);
    await recargarProceso(procesoSeleccionado.id);

    } catch (e) { informarError(e); }
  };

  const abrirInstancia = async (instancia) => {
    const res = await axios.post(`${API}/devuelveInstanciaEtapa`, {
      proceso_etapa_instancia_id: instancia.id,
    });

    setInstanciaActiva(res.data);
    setItemEdit(null);
    setMostrarCrearItem(false);
  };

  const editarInstanciaCompleta = (instancia) => {
    setErrorDetalle("");
    setInstanciaEdit({ id: instancia.id, nombre: instancia.nombre || "", orden: instancia.orden ?? 1, estado: instancia.estado || "pendiente" });
  };

  const guardarInstanciaCompleta = async () => {
    if (!instanciaEdit || guardandoDetalle) return;
    if (!instanciaEdit.nombre.trim()) { setErrorDetalle("El nombre es obligatorio"); return; }
    setGuardandoDetalle(true); setErrorDetalle("");
    try {
      await axios.post(`${API}/editarInstancia`, {
        id: instanciaEdit.id, nombre: instanciaEdit.nombre.trim(),
        orden: Number(instanciaEdit.orden), estado: instanciaEdit.estado,
      });
      await recargarProceso(procesoSeleccionado.id);
      setInstanciaEdit(null);
    } catch (e) { informarError(e, setErrorDetalle); }
    finally { setGuardandoDetalle(false); }
  };

  const editarItemCompleto = (item) => {
    setErrorDetalle("");
    let duracionVideo = 180;
    let observacion = item.observacion || "";
    try {
      const json = JSON.parse(observacion);
      if (json?.tipo === "video_entrevista") duracionVideo = json.duracionSegundos || 180;
    } catch (_) {}
    const reglaNumerica = leerReglaNumerica(observacion);
    setItemEdit({
      evaluacionNumerica: reglaNumerica.numerico,
      operadorNumerico: reglaNumerica.operador,
      umbralNumerico: reglaNumerica.umbral,
      id: item.id, nombre: item.nombre || "", tipo: item.tipo || "formulario",
      formulario_id: item.formulario_id ?? "", orden: item.orden ?? 1,
       visible: item.visible || "Todos", observacion, duracionVideo,
       texto_aprobado: item.texto_aprobado ?? "",
       texto_rechazado: item.texto_rechazado ?? "",
    });
  };

  const guardarItemCompleto = async () => {
    if (!itemEdit || guardandoDetalle) return;
    if (!itemEdit.nombre.trim()) { setErrorDetalle("El nombre del ítem es obligatorio"); return; }
    setGuardandoDetalle(true); setErrorDetalle("");
    try {
      const observacion = itemEdit.tipo === "video"
        ? JSON.stringify({ tipo: "video_entrevista", duracionSegundos: Number(itemEdit.duracionVideo) || 180,
            instancia: instanciaActiva.nombre, instancia_id: instanciaActiva.id })
        : armarReglaNumerica(itemEdit);
      await axios.post(`${API}/editarItem`, {
        id: itemEdit.id, nombre: itemEdit.nombre.trim(), tipo: itemEdit.tipo,
        formulario_id: itemEdit.tipo === "formulario" ? (itemEdit.formulario_id === "" ? null : Number(itemEdit.formulario_id)) : null,
                 orden: Number(itemEdit.orden), visible: itemEdit.visible || "Todos", observacion,
         texto_aprobado: itemEdit.texto_aprobado?.trim() || null,
         texto_rechazado: itemEdit.texto_rechazado?.trim() || null,
      });
      await abrirInstancia(instanciaActiva);
      setItemEdit(null);
    } catch (e) { informarError(e, setErrorDetalle); }
    finally { setGuardandoDetalle(false); }
  };

  const camposItemEdit = () => itemEdit && <div className="pb-form pb-edit-panel">
    <div className="pb-section-head"><h4>Editar ítem</h4><button className="pb-btn" onClick={() => setItemEdit(null)}>Cerrar</button></div>
    <div className="pb-fields">
      <label>Nombre<input value={itemEdit.nombre} onChange={e => setItemEdit(p => ({...p,nombre:e.target.value}))}/></label>
      <label>Tipo<select value={itemEdit.tipo} onChange={e => setItemEdit(p => ({...p,tipo:e.target.value}))}>
        {['formulario','archivo','video','evaluacion','credencial','check'].map(t => <option key={t} value={t}>{t}</option>)}
      </select></label>
      <label>Orden<input type="number" min="1" value={itemEdit.orden} onChange={e => setItemEdit(p => ({...p,orden:e.target.value}))}/></label>
      {itemEdit.tipo === 'formulario' && <label>ID de formulario<input type="number" value={itemEdit.formulario_id} onChange={e => setItemEdit(p => ({...p,formulario_id:e.target.value}))}/></label>}
      {itemEdit.tipo === 'video' && <label>Duración del video (segundos)<input type="number" min="1" value={itemEdit.duracionVideo} onChange={e => setItemEdit(p => ({...p,duracionVideo:e.target.value}))}/></label>}
    </div>
    <label>Visible para</label>
    <div className="pb-role-list">
      <label><input type="checkbox" checked={itemEdit.visible === 'Todos'} onChange={e => setItemEdit(p => ({...p,visible:e.target.checked?'Todos':''}))}/> Todos</label>
      {roles.map(rol => <label key={rol}><input type="checkbox" checked={itemEdit.visible.split(',').includes(rol)} onChange={e => setItemEdit(p => {
        const seleccion = p.visible === 'Todos' ? [] : p.visible.split(',').filter(Boolean);
        return {...p,visible:e.target.checked ? [...new Set([...seleccion,rol])].join(',') : seleccion.filter(x=>x!==rol).join(',')};
      })}/> {rol}</label>)}
    </div>
           <div className="pb-fields" style={{marginTop:12}}>
         <label>Texto público si está aprobado (opcional)
           <input maxLength={255} placeholder="Ej.: APTO, CUMPLIMENTA" value={itemEdit.texto_aprobado ?? ""} onChange={e => setItemEdit(p => ({...p, texto_aprobado:e.target.value}))}/>
         </label>
         <label>Texto público si está rechazado (opcional)
           <input maxLength={255} placeholder="Ej.: NO APTO, NO CUMPLIMENTA" value={itemEdit.texto_rechazado ?? ""} onChange={e => setItemEdit(p => ({...p, texto_rechazado:e.target.value}))}/>
         </label>
       </div>
       <p className="pb-meta">Vista previa: aprobado → <strong>{itemEdit.texto_aprobado?.trim() || "Aprobado"}</strong> · rechazado → <strong>{itemEdit.texto_rechazado?.trim() || "Rechazado"}</strong>. Los estados internos no cambian.</p>
       <ControlesReglaNumerica data={itemEdit} actualizar={(campo,valor) => setItemEdit(p => ({...p,[campo]:valor}))} />
       {itemEdit.tipo !== 'video' && !(itemEdit.tipo === 'evaluacion' && itemEdit.evaluacionNumerica) && <label>Observación<textarea rows="3" value={itemEdit.observacion} onChange={e => setItemEdit(p=>({...p,observacion:e.target.value}))}/></label>}
    {errorDetalle && <p className="pb-error">{errorDetalle}</p>}
    <div className="pb-actions"><button className="pb-btn pb-primary" disabled={guardandoDetalle} onClick={guardarItemCompleto}>{guardandoDetalle?'Guardando...':'Guardar ítem'}</button><button className="pb-btn" onClick={()=>setItemEdit(null)}>Cancelar</button></div>
  </div>;

  const armarObservacionItem = (data) => {
    if (data.tipo === "video") {
      return JSON.stringify({
        tipo: "video_entrevista",
        duracionSegundos: Number(data.duracionVideo || 180),
        instancia: instanciaActiva?.nombre || "",
        instancia_id: instanciaActiva?.id || null,
      });
    }

    return armarReglaNumerica(data);
  };

  const crearItem = async () => {
    setErrorGeneral("");
    try {
    const data = itemForm[instanciaActiva.id] || {};

    await axios.post(`${API}/crearItem`, {
      proceso_etapa_instancia_id: instanciaActiva.id,
      tipo: data.tipo || "formulario",
      nombre: data.nombre,
      formulario_id: data.formulario_id ? Number(data.formulario_id) : null,
      observacion: armarObservacionItem(data),
      orden: Number(data.orden || 1),
       visible: data.visible || "Todos",
       texto_aprobado: data.texto_aprobado?.trim() || null,
       texto_rechazado: data.texto_rechazado?.trim() || null,
    });

    setItemForm({});
    setMostrarCrearItem(false);
    await abrirInstancia(instanciaActiva);

    } catch (e) { informarError(e); }
  };

  const obtenerObservacionLegible = (item) => {
    if (!item?.observacion) return "";

    try {
      const obs = JSON.parse(item.observacion);

      if (obs?.tipo === "video_entrevista") {
        return ` - duración: ${obs.duracionSegundos || 180}s - instancia: ${
          obs.instancia || "-"
        }`;
      }

      return ` - ${item.observacion}`;
    } catch {
      return ` - ${item.observacion}`;
    }
  };

  const itemActual = itemForm[instanciaActiva?.id] || {};
  const tipoItemActual = itemActual.tipo || "formulario";

  const etapaSeleccionada = procesoSeleccionado?.etapas?.find((e) => e.id === etapaActiva?.id);
  const instanciaSeleccionada = etapaSeleccionada?.instancias?.find((i) => i.id === instanciaActiva?.id);

  return (
    <div className="pb-root">
      <header className="pb-header"><div><div className="pb-eyebrow">SIGEDI · Administración</div><h2>Constructor de procesos</h2><p>Organizá procesos, etapas, instancias e ítems sin perder el contexto.</p></div></header>
      {errorGeneral && <div className="pb-error" role="alert" style={{padding:12,marginBottom:12,whiteSpace:"pre-wrap"}}><strong>Error:</strong> {errorGeneral} <button type="button" className="pb-btn" onClick={() => setErrorGeneral("")}>Cerrar</button></div>}
      {!instanciaActiva && <section className="pb-panel">
        <div className="pb-section-head"><h3>Procesos</h3><button className="pb-btn pb-primary" onClick={() => setMostrarCrearProceso(!mostrarCrearProceso)}>{mostrarCrearProceso ? "Cancelar" : "+ Nuevo proceso"}</button></div>
        {mostrarCrearProceso && <div className="pb-form"><div className="pb-fields"><label>Nombre<input value={nombreProceso} onChange={(e) => setNombreProceso(e.target.value)} placeholder="Nombre del proceso" /></label><label>Descripción<input value={descripcion} onChange={(e) => setDescripcion(e.target.value)} placeholder="Descripción" /></label><label>Formulario asociado (obligatorio)
          {!usarIdManual ? (
            <select value={formularioId} onChange={e => setFormularioId(e.target.value)} disabled={cargandoFormularios}>
              <option value="">{cargandoFormularios ? "Cargando formularios..." : "Seleccionar formulario"}</option>
              {formularios.map(f => <option key={f.id} value={String(f.id)}>N.º {f.id} — {f.nombre}</option>)}
            </select>
          ) : (
            <input type="number" min="1" step="1" value={formularioId} onChange={e => setFormularioId(e.target.value)} placeholder="ID de formulario" />
          )}
        </label>
        <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
          <button type="button" className="pb-btn" onClick={cargarFormularios} disabled={cargandoFormularios}>{cargandoFormularios ? "Consultando..." : "Actualizar formularios"}</button>
          <label style={{display:"flex",alignItems:"center",gap:6}}><input type="checkbox" checked={usarIdManual} onChange={e => {setUsarIdManual(e.target.checked);setFormularioId("");}} /> Ingresar ID manualmente</label>
        </div>
        {errorFormularios && <p className="pb-error" role="alert">No se pudieron cargar los formularios: {errorFormularios}. Verificá la ruta del endpoint.</p>}
        <label>Escuela (obligatorio)<select value={escuelaProceso} onChange={e => setEscuelaProceso(e.target.value)}><option value="">Seleccionar escuela</option>{ESCUELAS.map(e => <option key={e} value={e}>{e}</option>)}</select></label>
        <label>Tipo de proceso (obligatorio)<select value={tipoProceso} onChange={e => setTipoProceso(e.target.value)}><option value="">Seleccionar tipo</option>{TIPOS_PROCESO.map(t => <option key={t} value={t}>{t}</option>)}</select></label>
        <label>Estado<select value={estadoProceso} onChange={e => setEstadoProceso(e.target.value)}>{ESTADOS_PROCESO.map(t => <option key={t} value={t}>{t}</option>)}</select></label>
        {[
          ["fecha_inicio", "Inicio del proceso"],
          ["fecha_finalizacion", "Finalización del proceso"],
          ["fecha_inicio_recurrir", "Inicio de recursiva (opcional)"],
          ["fecha_finalizacion_recurrir", "Finalización de recursiva (opcional)"],
        ].map(([campo, etiqueta]) => <label key={campo}>{etiqueta}<input type="datetime-local" value={fechasProceso[campo]} onChange={e => setFechasProceso(prev => ({...prev, [campo]: e.target.value}))}/></label>)}
        </div><button className="pb-btn pb-primary" disabled={guardandoProceso} onClick={crearProceso}>{guardandoProceso ? "Creando..." : "Crear proceso"}</button></div>}
        <div className="pb-process-list">{procesos.map((p) => <button key={p.id} className={`pb-process ${procesoSeleccionado?.id === p.id ? "is-active" : ""}`} onClick={() => abrirProceso(p).catch(e => informarError(e))}>{p.nombre}</button>)}</div>
      </section>}
      {procesoSeleccionado && <>
        <nav className="pb-breadcrumb"><button onClick={() => {setProcesoSeleccionado(null);setEtapaActiva(null);setInstanciaActiva(null);}}>Procesos</button><span>›</span><button onClick={() => {setEtapaActiva(null);setInstanciaActiva(null);setEtapaEdit(null);}}>{procesoSeleccionado.nombre}</button>{etapaSeleccionada && <><span>›</span><button onClick={() => {setInstanciaActiva(null);setMostrarCrearItem(false);}}>{etapaSeleccionada.nombre}</button></>}{instanciaActiva && <><span>›</span><strong>{instanciaActiva.nombre}</strong></>}</nav>
        <section className="pb-panel"><div className="pb-section-head"><div><div className="pb-eyebrow">Proceso seleccionado</div><h3>{procesoSeleccionado.nombre}</h3></div>{etapaActiva && <button className="pb-btn" onClick={() => {setEtapaActiva(null);setInstanciaActiva(null);setEtapaEdit(null);}}>Ver todas las etapas</button>}</div>
          <div className="pb-stage-list">{procesoSeleccionado.etapas?.filter(etapa => !instanciaActiva || etapa.id === etapaActiva?.id).map((etapa) => <article key={etapa.id} className={`pb-stage ${etapaActiva?.id === etapa.id ? "is-selected" : ""}`}>
            <div className="pb-stage-row"><div className="pb-stage-info"><span className="pb-order">{etapa.orden ?? "—"}</span><div><div className="pb-stage-name">{renderEditable("Etapa", etapa)}</div><div className="pb-meta">{etapa.instancias?.length || 0} instancias · <span className={etapa.permite_recursiva ? "pb-enabled" : ""}>Recursiva {etapa.permite_recursiva ? "habilitada" : "deshabilitada"}</span></div></div></div><div className="pb-actions"><button className="pb-btn pb-primary" onClick={() => etapaActiva?.id === etapa.id ? (setEtapaActiva(null),setInstanciaActiva(null),setEtapaEdit(null)) : abrirEtapa(etapa)}>{etapaActiva?.id === etapa.id ? "Cerrar etapa" : "Abrir etapa"}</button><button className="pb-btn" onClick={() => {if (etapaActiva?.id !== etapa.id) abrirEtapa(etapa); cargarEdicionEtapa(etapa);}}>Editar campos</button><button className="pb-btn pb-icon" title="Subir" onClick={() => mover("Etapa", etapa, "up")}>↑</button><button className="pb-btn pb-icon" title="Bajar" onClick={() => mover("Etapa", etapa, "down")}>↓</button><button className="pb-btn pb-danger" onClick={() => eliminar("Etapa", etapa.id)}>Eliminar</button></div></div>
            {etapaActiva?.id === etapa.id && <div className="pb-stage-body">
              {etapaEdit?.id === etapa.id && <div className="pb-form"><div className="pb-section-head"><h4>Configuración de la etapa</h4><button className="pb-btn" onClick={() => {setEtapaEdit(null);setErrorEtapa("");}}>Cerrar edición</button></div>{camposEtapa(etapaEdit,(campo,valor) => setEtapaEdit(prev => ({...prev,[campo]:valor})))}{errorEtapa && <p className="pb-error">{errorEtapa}</p>}<button className="pb-btn pb-primary" disabled={guardandoEtapa} onClick={guardarEtapaCompleta}>{guardandoEtapa ? "Guardando..." : "Guardar cambios"}</button></div>}
              {!instanciaActiva && <><div className="pb-section-head"><h4>Instancias de esta etapa</h4><button className="pb-btn" onClick={() => setMostrarCrearInstancia(!mostrarCrearInstancia)}>{mostrarCrearInstancia ? "Cancelar" : "+ Nueva instancia"}</button></div><div className="pb-instance-list">{etapa.instancias?.map(inst => <div className="pb-instance" key={inst.id}><div><span className="pb-order pb-small">{inst.orden ?? "—"}</span>{renderEditable("Instancia",inst)}</div><div className="pb-actions"><button className="pb-btn pb-primary" onClick={() => abrirInstancia(inst).catch(e => informarError(e))}>Ver ítems →</button><button className="pb-btn" onClick={() => editarInstanciaCompleta(inst)}>Editar campos</button><button className="pb-btn pb-icon" onClick={() => mover("Instancia",inst,"up")}>↑</button><button className="pb-btn pb-icon" onClick={() => mover("Instancia",inst,"down")}>↓</button><button className="pb-btn pb-danger" onClick={() => eliminar("Instancia",inst.id)}>Eliminar</button></div></div>)}</div>{instanciaEdit && <div className="pb-form pb-edit-panel"><div className="pb-section-head"><h4>Editar instancia</h4><button className="pb-btn" onClick={()=>setInstanciaEdit(null)}>Cerrar</button></div><div className="pb-fields"><label>Nombre<input value={instanciaEdit.nombre} onChange={e=>setInstanciaEdit(p=>({...p,nombre:e.target.value}))}/></label><label>Orden<input type="number" min="1" value={instanciaEdit.orden} onChange={e=>setInstanciaEdit(p=>({...p,orden:e.target.value}))}/></label><label>Estado<input value={instanciaEdit.estado} onChange={e=>setInstanciaEdit(p=>({...p,estado:e.target.value}))}/></label></div>{errorDetalle && <p className="pb-error">{errorDetalle}</p>}<div className="pb-actions"><button className="pb-btn pb-primary" disabled={guardandoDetalle} onClick={guardarInstanciaCompleta}>{guardandoDetalle?'Guardando...':'Guardar instancia'}</button><button className="pb-btn" onClick={()=>setInstanciaEdit(null)}>Cancelar</button></div></div>}{!etapa.instancias?.length && <p className="pb-empty">Esta etapa todavía no tiene instancias.</p>}{mostrarCrearInstancia && <div className="pb-form"><h4>Nueva instancia</h4><div className="pb-fields"><label>Nombre de instancia<input value={instanciaForm[etapaActiva.id]?.nombre || ""} onChange={(e) => setForm(setInstanciaForm, etapaActiva.id, "nombre", e.target.value)} placeholder="Nombre" /></label><label>Orden<input type="number" min="1" value={instanciaForm[etapaActiva.id]?.orden || 1} onChange={(e) => setForm(setInstanciaForm, etapaActiva.id, "orden", e.target.value)} /></label></div><button className="pb-btn pb-primary" onClick={crearInstancia}>Crear instancia</button></div>}</>}
              {instanciaActiva && <div className="pb-detail"><div className="pb-section-head"><div><div className="pb-eyebrow">Instancia seleccionada</div><h4>{instanciaActiva.nombre}</h4></div><button className="pb-btn" onClick={() => {setInstanciaActiva(null);setMostrarCrearItem(false);}}>← Volver a instancias</button></div><div className="pb-item-list">{instanciaActiva.items?.map(item => <div className="pb-item" key={item.id}><div className="pb-item-info"><div>{renderEditable("Item",item)} <span className="pb-tag">{item.tipo}</span><span className="pb-tag">{item.visible}</span></div><div className="pb-meta">{obtenerObservacionLegible(item)}{(item.texto_aprobado || item.texto_rechazado) && <span> · Textos públicos: aprobado → {item.texto_aprobado || "Aprobado"} / rechazado → {item.texto_rechazado || "Rechazado"}</span>}</div></div><div className="pb-actions"><button className="pb-btn" onClick={() => editarItemCompleto(item)}>Editar campos</button><button className="pb-btn pb-icon" onClick={() => mover("Item",item,"up")}>↑</button><button className="pb-btn pb-icon" onClick={() => mover("Item",item,"down")}>↓</button><button className="pb-btn pb-danger" onClick={() => eliminar("Item",item.id)}>Eliminar</button></div></div>)}</div>{camposItemEdit()}{!instanciaActiva.items?.length && <p className="pb-empty">Esta instancia todavía no tiene ítems.</p>}<button className="pb-btn pb-primary" onClick={() => setMostrarCrearItem(!mostrarCrearItem)}>{mostrarCrearItem ? "Cancelar" : "+ Nuevo ítem"}</button>{mostrarCrearItem && <div className="pb-form pb-item-form"><h4>Nuevo ítem</h4>                <input
                  placeholder="Nombre"
                  value={itemForm[instanciaActiva.id]?.nombre || ""}
                  onChange={(e) =>
                    setForm(
                      setItemForm,
                      instanciaActiva.id,
                      "nombre",
                      e.target.value
                    )
                  }
                />

                <select
                  value={itemForm[instanciaActiva.id]?.tipo || "formulario"}
                  onChange={(e) =>
                    setForm(
                      setItemForm,
                      instanciaActiva.id,
                      "tipo",
                      e.target.value
                    )
                  }
                >
                  <option value="formulario">Formulario</option>
                  <option value="archivo">Archivo</option>
                  <option value="video">Video entrevista</option>
                  <option value="evaluacion">Evaluación</option>
                  <option value="credencial">Credencial QR</option>
                  <option value="check">Check</option>
                </select>

                {tipoItemActual === "formulario" && (
                  <input
                    placeholder="Formulario ID"
                    value={itemForm[instanciaActiva.id]?.formulario_id || ""}
                    onChange={(e) =>
                      setForm(
                        setItemForm,
                        instanciaActiva.id,
                        "formulario_id",
                        e.target.value
                      )
                    }
                  />
                )}

                {tipoItemActual === "video" && (
                  <div
                    style={{
                      marginTop: 10,
                      padding: 10,
                      background: "#f1f5f9",
                      borderRadius: 8,
                    }}
                  >
                    <strong>Configuración del video</strong>

                    <div style={{ marginTop: 8 }}>
                      <input
                        type="number"
                        placeholder="Duración en segundos"
                        value={
                          itemForm[instanciaActiva.id]?.duracionVideo || 180
                        }
                        onChange={(e) =>
                          setForm(
                            setItemForm,
                            instanciaActiva.id,
                            "duracionVideo",
                            e.target.value
                          )
                        }
                      />

                      <span style={{ marginLeft: 8 }}>
                        Instancia: <strong>{instanciaActiva.nombre}</strong>
                      </span>
                    </div>

                    <small>
                      Esto se guardará en observación como JSON para que el
                      grabador sepa cuánto debe durar.
                    </small>
                  </div>
                )}

                <div style={{ marginTop: 10 }}>
                  {roles.map((rol) => (
                    <label key={rol} style={{ marginRight: 10 }}>
                      <input
                        type="checkbox"
                        checked={(itemForm[instanciaActiva.id]?.visible || "")
                          .split(",")
                          .includes(rol)}
                        onChange={(e) => {
                          let actuales = (
                            itemForm[instanciaActiva.id]?.visible || ""
                          )
                            .split(",")
                            .filter(Boolean);

                          if (e.target.checked) {
                            actuales.push(rol);
                          } else {
                            actuales = actuales.filter((r) => r !== rol);
                          }

                          setForm(
                            setItemForm,
                            instanciaActiva.id,
                            "visible",
                            actuales.join(",")
                          );
                        }}
                      />
                      {rol}
                    </label>
                  ))}
                </div>

                <ControlesReglaNumerica
                  data={{ ...itemActual, tipo: tipoItemActual }}
                  actualizar={(campo, valor) => setForm(setItemForm, instanciaActiva.id, campo, valor)}
                />

                {tipoItemActual !== "video" && !(tipoItemActual === "evaluacion" && itemActual.evaluacionNumerica) && (
                  <input
                    placeholder="Observación"
                    value={itemForm[instanciaActiva.id]?.observacion || ""}
                    onChange={(e) =>
                      setForm(
                        setItemForm,
                        instanciaActiva.id,
                        "observacion",
                        e.target.value
                      )
                    }
                  />
                )}

                                 <div className="pb-fields" style={{marginTop:12}}>
                   <label>Texto público si está aprobado (opcional)
                     <input maxLength={255} placeholder="Ej.: APTO, CUMPLIMENTA" value={itemActual.texto_aprobado || ""} onChange={e => setForm(setItemForm, instanciaActiva.id, "texto_aprobado", e.target.value)}/>
                   </label>
                   <label>Texto público si está rechazado (opcional)
                     <input maxLength={255} placeholder="Ej.: NO APTO, NO CUMPLIMENTA" value={itemActual.texto_rechazado || ""} onChange={e => setForm(setItemForm, instanciaActiva.id, "texto_rechazado", e.target.value)}/>
                   </label>
                 </div>
                 <p className="pb-meta">Vista previa: aprobado → <strong>{itemActual.texto_aprobado?.trim() || "Aprobado"}</strong> · rechazado → <strong>{itemActual.texto_rechazado?.trim() || "Rechazado"}</strong>.</p>
                 <button onClick={crearItem}>Agregar item</button></div>}</div>}
            </div>}
          </article>)}</div>
          {!etapaActiva && <div className="pb-create-stage"><button className="pb-btn pb-primary" onClick={() => setMostrarCrearEtapa(!mostrarCrearEtapa)}>{mostrarCrearEtapa ? "Cancelar" : "+ Nueva etapa"}</button>{mostrarCrearEtapa && <div className="pb-form"><h4>Crear etapa</h4>{camposEtapa(etapaForm[procesoSeleccionado.id] || {},(campo,valor) => setForm(setEtapaForm,procesoSeleccionado.id,campo,valor))}{errorEtapa && <p className="pb-error">{errorEtapa}</p>}<button className="pb-btn pb-primary" onClick={crearEtapa} disabled={guardandoEtapa}>{guardandoEtapa ? "Guardando..." : "Guardar nueva etapa"}</button></div>}</div>}
        </section>
      </>}
    </div>
  );
};

export default ProcesosBuilder;
